import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { UserReducer } from "../reducers/UserReducer";

const UserContext = createContext({
	state: UserReducer.getInitialState(),
	actions: UserReducer.actions,
});

export const useUserContext = () => useContext(UserContext);

export const UserProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: UserReducer.getInitialState(),
		reducers: UserReducer.caseReducers,
	});

	return (
		<UserContext.Provider value={{ state, actions }}>
			{children}
		</UserContext.Provider>
	);
};
